/* Shared product carousel behaviour: clone loop, drag, arrow stepping.
   Extracted from sections/product-carousel.liquid 2026-07-31 so sections/inspiration-listing.liquid
   can reuse it. Sections cannot share {% javascript %} blocks, hence the asset file.
   Edit here, not in either section. */
  document.querySelectorAll('.cc-product-carousel__viewport').forEach(function (viewport) {
    if (viewport.hasAttribute('data-rv-viewport')) return; // Recently Viewed has its own handler
    // Both product-carousel and inspiration-listing include this asset, so it can execute twice on
    // one page. Without this guard each viewport would be initialised twice and clone its cards twice.
    if (viewport.dataset.ccPcReady === '1') return;
    viewport.dataset.ccPcReady = '1';
    var track = viewport.querySelector('.cc-product-carousel__grid');
    var prev = viewport.querySelector('.cc-product-carousel__arrow--prev');
    var next = viewport.querySelector('.cc-product-carousel__arrow--next');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var perStep = Math.max(parseInt(track.dataset.scrollStep, 10) || 1, 1);
    var setWidth = 0;
    var loopEnabled = false;

    function measure() {
      setWidth = 0;
      originals.forEach(function (el) { setWidth += el.getBoundingClientRect().width + gap; });
    }

    if (track.scrollWidth - track.clientWidth > 4) {
      measure();
      if (setWidth > 0) {
        loopEnabled = true;
        var before = document.createDocumentFragment();
        var after = document.createDocumentFragment();
        originals.forEach(function (el) {
          [before, after].forEach(function (frag) {
            var clone = el.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.tabIndex = -1;
            clone.classList.add('is-clone');
            frag.appendChild(clone);
          });
        });
        track.appendChild(after);
        track.insertBefore(before, track.firstChild);
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = setWidth;
        track.style.scrollBehavior = prevBehavior;
      }
    }

    function recenter() {
      if (!loopEnabled) return;
      var sl = track.scrollLeft;
      if (sl < setWidth * 0.5 || sl > setWidth * 1.5) {
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = sl < setWidth * 0.5 ? sl + setWidth : sl - setWidth;
        track.style.scrollBehavior = prevBehavior;
      }
    }

    function step(direction) {
      recenter();
      var cardW = originals[0].getBoundingClientRect().width + gap;
      var amount = cardW * perStep;
      if (loopEnabled) amount = Math.min(amount, setWidth * 0.9);
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // 'heading' arrow layout uses the cc-heading arrows (beside the title). Intercept them capture-phase
    // and scroll THIS carousel's own track — cc-heading's default handler targets the first matching grid
    // on the page, so it breaks with more than one carousel. Also gives a 1-card step.
    var section = viewport.closest('.cc-product-carousel');
    var headArrows = section && section.querySelector('.cc-heading__arrows');
    if (headArrows) {
      headArrows.addEventListener('click', function (e) {
        var btn = e.target.closest('.cc-heading__arrow');
        if (!btn) return;
        e.stopPropagation();
        step(btn.classList.contains('cc-heading__arrow--prev') ? -1 : 1);
      }, true);
    }

    var settleTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(recenter, 120);
    });

    window.addEventListener('resize', function () { if (loopEnabled) measure(); });
  });

  // Recently Viewed — read handles from localStorage, fetch each card via /products/{handle}?view=card.
  function initRvScroll(vp, track) {
    var prev = vp.querySelector('.cc-product-carousel__arrow--prev');
    var next = vp.querySelector('.cc-product-carousel__arrow--next');
    function cardW() {
      var el = track.children[0];
      if (!el) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return el.getBoundingClientRect().width + gap;
    }
    function update() {
      var overflowing = track.scrollWidth - track.clientWidth > 4;
      if (prev) prev.hidden = !overflowing;
      if (next) next.hidden = !overflowing;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardW(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardW(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('[data-rv-viewport]').forEach(function (vp) {
    if (vp.dataset.ccPcRvReady === '1') return;
    vp.dataset.ccPcRvReady = '1';
    var section = vp.closest('.cc-product-carousel');
    var track = vp.querySelector('[data-rv-track]');
    var limit = parseInt(vp.getAttribute('data-rv-limit'), 10) || 8;
    var current = vp.getAttribute('data-rv-current') || '';
    var productId = vp.getAttribute('data-rv-product-id') || '';
    var fallback = (vp.getAttribute('data-rv-fallback') || '').split(',').filter(Boolean);

    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('cc:recently-viewed') || '[]'); } catch (e) {}
    if (!Array.isArray(handles)) handles = [];
    handles = handles.filter(function (h) { return h && h !== current; }).slice(0, limit);

    // Track what's already queued so top-up products don't duplicate.
    var used = {};
    handles.forEach(function (h) { used[h] = 1; });
    if (current) used[current] = 1;
    function topUp(pool) {
      for (var i = 0; i < pool.length && handles.length < limit; i++) {
        var h = pool[i];
        if (h && !used[h]) { used[h] = 1; handles.push(h); }
      }
    }

    // When recently-viewed is short, and fill is enabled, top up with Shopify's related
    // recommendations (on a product page) then any fallback collection, so it's not sparse/blank.
    var doFill = vp.hasAttribute('data-rv-fill');
    var recPromise = Promise.resolve([]);
    if (doFill && handles.length < limit && productId) {
      recPromise = fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&intent=related&limit=10')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d.products || []).map(function (p) { return p.handle; }); })
        .catch(function () { return []; });
    }

    recPromise.then(function (recs) {
      if (doFill) {
        topUp(recs);
        if (handles.length < limit) topUp(fallback);
      }
      if (!handles.length) { if (section) section.remove(); return; }

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=card')
          .then(function (r) {
            // A recently-viewed handle can be for a product that's since been discontinued or
            // renamed. Shopify keeps a URL redirect pointing the old handle somewhere else (often
            // a collection) rather than a hard 404. fetch() follows that redirect silently and the
            // target still answers 200 OK, so `r.ok` alone isn't enough to trust the body as a
            // card fragment — it can be an entire full-layout page instead. Injecting that wholesale
            // wrecked the whole row: a full <head>/page crammed into one flex item stretches every
            // sibling card to match it (the row's default align-items: stretch), which is what made
            // "Recently Viewed" look broken sitewide even though every OTHER card was fine.
            // r.redirected is the reliable signal — a genuine card fragment is served directly, with
            // no redirect in the chain, so treat any redirected response as a miss, same as a 404.
            if (!r.ok || r.redirected) return '';
            return r.text();
          })
          .then(function (html) {
            // Belt-and-braces in case a full page is ever returned without a technical redirect
            // (e.g. a proxy/CDN rewrite) — a real card fragment (`layout: none`) never has a
            // doctype or <head>, so bail rather than trust it.
            if (html.indexOf('<!doctype') !== -1 || html.indexOf('<head') !== -1) return '';
            return html;
          })
          .catch(function () { return ''; });
      })).then(function (parts) {
        var html = parts
          .filter(function (p) { return p && p.trim(); })
          .map(function (p) { return '<div class="cc-product-carousel__item">' + p + '</div>'; })
          .join('');
        if (!html) { if (section) section.remove(); return; }
        track.innerHTML = html;
        if (section) section.hidden = false;
        initRvScroll(vp, track);
      });
    });
  });
